module.exports = __webpack_public_path__ + "img/googlePlay.bd027132.png";